import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface CatalogPositionGroup {
    groupName: string;
    positionIds: number[];
    displayName: string;
}

export interface CatalogPart {
    partTerminologyId: number;
    partTerminologyName: string;
    positionGroups: CatalogPositionGroup[];
    allPositionIds: number[];
}

export interface CatalogSubcategory {
    subcategoryId: number;
    subcategoryName: string;
    partCount: number;
    parts: CatalogPart[];
}

export interface CatalogCategory {
    categoryId: number;
    categoryName: string;
    subcategoryCount: number;
    subcategories: CatalogSubcategory[];
}

interface GetPCDBCatalogResponse {
    categories: CatalogCategory[];
}

const getPCDBCatalog = async (sessionId: string): Promise<GetPCDBCatalogResponse> => {
    const { data } = await axios.get(`${API_URL}/pcdb/catalog`, {
        headers: {
            Authorization: sessionId
        }
    });
    return data;
};

export const useGetPCDBCatalog = (enabled: boolean = true) => {
    const sessionContext = useContext(SessionContext);

    return useQuery({
        queryKey: ['pcdb', 'catalog'],
        queryFn: () => getPCDBCatalog(sessionContext?.sessionId ?? ''),
        enabled: !!sessionContext?.sessionId && enabled,
        staleTime: 5 * 60 * 1000,
    });
};
